import {lerp, register} from '../utils'

export const moving = register('moving', {
    priority: -20,
    initialize() {
        this.vector = this.vector || {x: 0, y: 0, rotation: 0, scale: 1, opacity: 1}
        this.$.movement = this.vector
    },
    methods: {
        update(dt) {
            this.$.x += (this?.vector?.x ?? 0) * dt
            this.$.y += (this?.vector?.y ?? 0) * dt
            this.$.rotation += (this?.vector?.rotation ?? 0) * dt

            this.$.scale = lerp(
                this.$.scale ?? 1,
                (this.$.scale ?? 1) * (this?.vector?.scale ?? 1),
                dt
            )
            this.$.opacity = lerp(
                this.$.opacity ?? 1,
                (this.$.opacity ?? 1) * (this?.vector?.opacity ?? 1),
                dt
            )
        },
    },
})
